import React from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import BannerSlider from './Home/Slider';
import CreateOwnDiamond from './Home/CreateOwnDiamond';
import OurCollection from './Home/OurCollection';
import { ShopDiamondShape } from './Home/ShopDiamondShape';
import WhatPeopleSay from './Home/WhatPeopleSay';
import { InstagramFeed } from './Home/InstagramFeed';
import { Newsletter } from './Home/Newsletter';
import BestSellingProduct from './Home/BestSellingProduct';
// import { Theme } from '../../../../../Helpers/request';

// if(Theme === 'newyork'){
//   require(`../assets/css/newyork.css`);
// }

const NewYorkHome = () => {

  return (
    <div className='newyork-home'>
      <BannerSlider />
      <CreateOwnDiamond /> 
      <OurCollection />
      <BestSellingProduct />
      <ShopDiamondShape />
      <WhatPeopleSay />
      <InstagramFeed />
      <Newsletter />
    </div> 
  )
}

export default NewYorkHome;